import React, { useState, useRef, useImperativeHandle, forwardRef, useEffect } from 'react';
import {
    Modal,
    Button,
    Form,
    Step,
    Checkbox,
    Input,
    Divider,
    Icon,
    Message,
    StepTitle,
    StepDescription,
    StepContent,
    Container,
} from 'semantic-ui-react';
import { PAYMENT_METHOD } from '../../../utils/business';

export const ReviewStep = forwardRef(({ initialData, cart, totals, shippingData, billingData }, ref) => {
    const [terms, setTerms] = useState(initialData?.terms || false);
    const [privacy, setPrivacy] = useState(initialData?.privacy || false);
    const [marketing, setMarketing] = useState(initialData?.marketing || false);
    const [signature, setSignature] = useState(initialData?.signature || '');
    const [localErrors, setLocalErrors] = useState({});

    useImperativeHandle(ref, () => ({
        validate: () => {
            const e = {};
            if (!terms) e.terms = 'Musíte súhlasiť s obchodnými podmienkami';
            if (!privacy) e.privacy = 'Musíte súhlasiť s ochranou osobných údajov';
            if (!signature) e.signature = 'Zadajte svoj podpis (meno) pre potvrdenie';
            setLocalErrors(e);
            return Object.keys(e).length === 0;
        },
        getValues: () => ({ terms, privacy, marketing, signature }),
    }));

    return (
        <div>
            <Message info>
                <Message.Header>Skontrolujte objednávku</Message.Header>
                <p>Skontrolujte, či sú všetky údaje správne.</p>
            </Message>
            <div style={{ marginBottom: 12 }}>
                <strong>Doručenie</strong>
                <div>{shippingData.fullName}</div>
                <div>{shippingData.address}, {shippingData.city} {shippingData.zip}</div>
            </div>
            <div style={{ marginBottom: 12 }}>
                <strong>Faktúra</strong>
                {billingData.sameAsShipping ? (
                    <div>Rovnaké ako doručenie</div>
                ) : (
                    <div>
                        {billingData.companyPurchase && <div>{billingData.company}</div>}
                        <div>{billingData.address}, {billingData.city} {billingData.zip}</div>
                    </div>
                )}
            </div>
            <div style={{ marginBottom: 12 }}>
                <strong>Platba</strong>
                <div>{billingData.paymentMethod === PAYMENT_METHOD.CASH_ON_DELIVERY ? 'Dobierka' : 'Platba kartou cez GoPay'}</div>
            </div>

            <Form>
                <Form.Field>
                    <Checkbox
                        label={{
                            children: (
                                <>
                                    Súhlasím s{" "}
                                    <a href="/legal" target="_blank">
                                        obchodnými podmienkami
                                    </a>{" "}
                                    *
                                </>
                            ),
                        }}
                        checked={terms}
                        onChange={(e, d) => setTerms(d.checked)}
                    />
                    {localErrors.terms && <Message negative size='tiny' content={localErrors.terms} />}
                </Form.Field>
                <Form.Field>
                    <Checkbox
                        label={{
                            children: (
                                <>
                                    Súhlasím so{" "}
                                    <a href="/gdpr" target="_blank">
                                        spracovaním osobných údajov
                                    </a>{" "}
                                    *
                                </>
                            ),
                        }}
                        checked={privacy} onChange={(e, d) => setPrivacy(d.checked)} />
                    {localErrors.privacy && <Message negative size='tiny' content={localErrors.privacy} />}
                </Form.Field>
                <Form.Field>
                    <Checkbox label='Súhlas so zasielaním marketingových správ (dobrovoľné)' checked={marketing} onChange={(e, d) => setMarketing(d.checked)} />
                </Form.Field>
                <Form.Field error={!!localErrors.signature}>
                    <label>Podpis *</label>
                    <Input value={signature} onChange={(e) => setSignature(e.target.value)} />
                    {localErrors.signature && <Message negative size='tiny' content={localErrors.signature} />}
                </Form.Field>
            </Form>
        </div>
    );
});